let endpoint = process.env.REACT_APP_BASE_URL;
export const endPoints = {
  title: "VidCraftAI",
  login: endpoint + "login",
  forgot_password: endpoint + "forgotPassword",
  reset_password: endpoint + "passwordReset",
  verifytoken : endpoint + "verifytoken",

  insertApikeys: endpoint + "setting/insert",
  fetchKeys: endpoint + "setting/fetch",
  tutorials: endpoint + "setting/fetchTutorials",
  updateApikeys: endpoint + "setting/update",
  fetchTemplates: endpoint + "templates",
  makeFav: endpoint + "templates/makeFav",
  removeFav: endpoint + "templates/removeFav",
  fetchScenes: endpoint + "templates/fetchScenes",
  checkCampaignExits: endpoint + "campaigns/checkCampaign",
  insertCampaign: endpoint + "campaigns/insert",
  createCampaign: endpoint + "campaigns/createCampaign",
  uploadVideo: endpoint + "campaigns/uploadVideo",
  getAllCampaign: endpoint + "campaigns/getCampaigns",
  getAllCampaigns: endpoint + "campaigns/getAllCampaigns",

  fetchCampaign: endpoint + "campaigns/fetchcamp",
  deleteCampaign: endpoint + "campaigns/deleteCampaign",
  updateCampaign: endpoint + "campaigns/updateCampaign",

  uploadImage: endpoint + "campaigns/uploadImage",
  myGallery: endpoint + "campaigns/myImages",
  saveImageData: endpoint + "campaigns/saveImageData",

  genImage: endpoint + "openai/genImage",
  genQuote: endpoint + "openai/genQuote",
  rewriteContent: endpoint + "openai/genQuote",

  // 7-6-2022
  myMedia: endpoint + "campaigns/myMedia",
  trimVideo: endpoint + "campaigns/trimVideo",

  cloneCampaignRequest: endpoint + "campaigns/cloneCampaign",
  fetchImageURL: endpoint + "campaigns/uploadURLImage",
  saveDraft: endpoint + "campaigns/saveVideoData",
  setAudio: endpoint + "campaigns/configureAudio",
  setRestartRender: endpoint + "campaigns/restartRender",

  getAllusers: endpoint + "users/getall",
  deleteUser: endpoint + "users/deleteUser",
  activateUser: endpoint + "users/activateUser",
  createUser: endpoint + "users/createUser",
  getUser: endpoint + "users/getUser",
  updateUser: endpoint + "users/updateUser",
  updateprofile: endpoint + "users/updateprofile",
  restrictUser: endpoint + "users/restrictUser",
  checkTos : endpoint + "users/checktos",
  acceptTos : endpoint + "users/accepttos",
  getAllTemplates: endpoint + "templates/getall",
  getTemplate: endpoint + "templates/getTemplate",
  deleteTemplate: endpoint + "templates/deleteTemplate",
  createTemplate: endpoint + "templates/createTemplate",
  updateTemplate: endpoint + "templates/updateTemplate",
  activateTemplate: endpoint + "templates/activateTemplate",
  // 23-02-2022
  fetchLandingPage: endpoint + "landing/fetch",
  insertLandingpage: endpoint + "landing/insert",
  updateLandingpage: endpoint + "landing/update",
  changLandingpage: endpoint + "landing/switchLandingPage",
  updateExistingLandingPage: endpoint + "landing/updateExistingLandingPage",

  //personalize
  addPersonalize: endpoint + "personalize/insert",
  getPersonalize: endpoint + "personalize/fetchData",
  deletePersonalize: endpoint + "personalize/deleteData",
  gifCreation: endpoint + "campaigns/gifCreation",
  // webpush
  webpushStatus: endpoint + "webpush/status",
  unsubscribe: endpoint + "webpush/unsubscribe",

  // analytics
  fetchStats: endpoint + "analytics/getStats",
  downloadCsv: endpoint + "analytics/export-csv",

  //sendmail
  sendMailData: endpoint + "mailer/sendmail",

  //settings
  updateSmtpDetails: endpoint + "setting/updateDetails",
  updateApiStting: endpoint + "setting/updateDetails",
  getSettingData: endpoint + "setting/fetch",
  updateProductDetails : endpoint + "setting/updateProduct",
  getProductDetails : endpoint + "setting/getProductDetails",
  fetchProduct : endpoint + "setting/getProductDetail/",
  insertAccess : endpoint + "setting/insertAccess",
  fetchAccess : endpoint + "setting/fetchAccess",
  updateAccess : endpoint + "setting/updateAccess",
  deleteAccess : endpoint + "setting/deleteAccess",

  //Autoresponder
  fetchAllKeys: endpoint + "autoresponder/fetchAllKeys",
  validateActiveCampaign: endpoint + "autoresponder/validateActivecamp",
  insertAutoresponderkeys: endpoint + "autoresponder/inserKeys",
  disconnectResponder: endpoint + "autoresponder/disconnectResponder",
  activeCampaignLists: endpoint + "autoresponder/getActiveCampaignList",

  //aweber
  aweberLists: endpoint + "autoresponder/getAweberLists",

  //mailchimp
  validateMailchimpCampaign: endpoint + "autoresponder/validateMailchimp",
  mailchimpLists: endpoint + "autoresponder/getMailchimpLists",

  // getResponse
  validateGetresponse: endpoint + "autoresponder/validateGetresponse",
  getResponseLists: endpoint + "autoresponder/getGetresponseLists",

  getPollData: endpoint + "pollaction/getPollData",
  getCreditsData : endpoint + "campaigns/fetchVideoCredits",

  //Research 
  searchBusiness : endpoint + "research/getResearchData",
  getReviews : endpoint + "research/getReviews",
  getYelpReviews: endpoint + "research/getYelpReviews",
  getSummery : endpoint + "openai/getSummery",


};
